module.exports = __webpack_public_path__ + "static/media/services-bg-4.a1ac7e59.webp";